const StorageKeys = Object.freeze({
  APP_USER: "appUser",
  APP_PERFIL: "appPerfil",
  APP_CANAL: "appCanal",
  APP_ROL_CREDITO: "appRolCredito",
  AUTH_USERNAME: "authUsername",
  AUTH_PASSWORD: "authPassword",
  AUTH_ID: "id",
  COTIZACION_ID: "kesp_cotizacion_id",
  CLIENTE_CODIGO: "affariClienteCodigo",
  LISTA_PRECIO_BASE: "affariListaPrecioBase",
  ALMACEN: "affariAlmacen",
  SELECTED_ALMACEN: "selectedCatalogWarehouse",
  GETNET_KEY: "kesp_getnet_key",
  GETNET_PEDIDO: "kesp_getnet_pedido",
  COMPANY_FALLBACK: "kesp_company_fallback",
});

const session = {
  get: (key) => sessionStorage.getItem(key),
  set: (key, value) => sessionStorage.setItem(key, value),
  remove: (key) => sessionStorage.removeItem(key),
};

const local = {
  get: (key) => localStorage.getItem(key),
  set: (key, value) => localStorage.setItem(key, value),
  remove: (key) => localStorage.removeItem(key),
};

export { StorageKeys, session, local };
